export default {'version' : '1.0-19-ga151142'};
